import CardWithBackgroundImage from '~/components/CardWithBackgroundImageBanner';
import { useBrand, useTranslation } from '@edreamsodigeo/frontend-core';
import ValuePropositionHeader from '~/components/ValueProposition/components/ValuePropositionHeader';
import React from 'react';
import getBrandedImage from '~/utils/getBrandedImage';
import { Body } from '@edreamsodigeo/prisma-design-system';

const ValuePropositionMobile = () => {
  const { t } = useTranslation();
  const brand = useBrand();

  return (
    <CardWithBackgroundImage
      title={<ValuePropositionHeader />}
      description={
        <Body type="xSmall" color="neutral.90">
          {t('supportarea.mytripslogin.banner.text')}
        </Body>
      }
      backgroundColor="primary.20"
      backgroundSize="120px"
      backgroundPosition={`calc(100% + 30px) calc(100% + 15px)`}
      backgroundImage={getBrandedImage(
        'BSA_images_SA.png',
        brand,
        '/images/SEP/SA/'
      )}
    />
  );
};

export default ValuePropositionMobile;
